module.exports = "../dist/frontend/icons/logo/gold.svg?e076814f51dc708ac6513754d7798613";